import React, { useEffect, useState } from 'react'
import { amount_img, build_img, cart_img, chat_img, home_img, lock_dash_img, mmc_dash_img, mmc_img } from '../../assets/imgs'
import PropertyBox from '../../components/Dashboard/PropertyBox'
import LocationBox from '../../components/Dashboard/LocationBox'
import DateSelected from '../../components/Dashboard/DateSelected'
import BookingsChart from '../../components/Dashboard/BookingsChart'
import { useDashboardDateDetailsMutation, useDashboardDetailsMutation } from '../redux/api/api'
import moment from 'moment'
import CurrentDateSelected from '../../components/Dashboard/CurrentDateSelected'
import BookingBox from '../../components/Dashboard/BookingBox'
import MainBox from '../../components/Dashboard/MainBox'

const Dashboard = () => {
    const [list, setList] = useState([]);
    const [dateList, setDateList] = useState([]);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();

    const [dashboardDetailsApi] = useDashboardDetailsMutation();
    const [dashboardDateDetailsApi] = useDashboardDateDetailsMutation();


    const dashDetails = () => {
        dashboardDetailsApi()
            .unwrap()
            .then((res) => {
                setList(res?.data)
            })
            .catch((err) => {
                console.log("err", err)
            })
    }
    const dashDateDetails = (fromDate, toDate) => {
        const formdata = new FormData();
        if (fromDate) {
            formdata.append("from_date", moment(fromDate).format("DD-MM-YYYY"));
        }
        if (toDate) {
            formdata.append("to_date", moment(toDate).format("DD-MM-YYYY"));
        }
        setFromDate(fromDate)
        setToDate(toDate)
        dashboardDateDetailsApi(formdata)
            .unwrap()
            .then((res) => {
                setDateList(res?.data)
                console.log("kkk", res?.data)


            })
            .catch((err) => {
                console.log("err", err)
            })
    }

    useEffect(() => {
        dashDetails()
        dashDateDetails()
    }, [])


    return (
        <div className="dashRightView home_section">
            <MainBox list={list} />
            <PropertyBox list={list} />
            <LocationBox list={list} />
            <BookingBox list={list} />

            <CurrentDateSelected
                dateList={dateList}
                setFromDate={setFromDate}
                setToDate={setToDate}
                fromDate={fromDate}
                toDate={toDate}
                dashDateDetails={dashDateDetails} />

            <BookingsChart dateList={dateList} />

        </div>
    )
}

export default Dashboard